import React, { createContext, useContext } from 'react'
import { message } from 'antd'

export const MessageContext = createContext<
  ReturnType<typeof message.useMessage>[0]
>(null!)

export function MessageProvider(props: React.PropsWithChildren<{}>) {
  const { children } = props
  const [instance, messageContext] = message.useMessage()
  return (
    <MessageContext.Provider value={instance}>
      {children}
      {messageContext}
    </MessageContext.Provider>
  )
}

export function useMessage() {
  return useContext(MessageContext)
}
